export default __webpack_public_path__ + "static/media/blobs-no-3.c9fce845.ogg";